<template>
    <v-card flat>
        <v-toolbar color="bal-gray" dense>
            <v-toolbar-title>{{
                    `${companyBankAccountNames[activeAccount.id] ? companyBankAccountNames[activeAccount.id] : 'Account'}`
                }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDrawer()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "Info" | t }}
            </v-tab>

            <v-tab-item>
                <consent-account-info-tab />
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Transaction days" | t }}
            </v-tab>

            <v-tab-item>
                <consent-account-transaction-days-tab/>
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Consents" | t }}
            </v-tab>

            <v-tab-item>
                <consent-account-consents-tab />
            </v-tab-item>

        </v-tabs>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import ConsentAccountTransactionDaysTab from "@/components/consent/consent-account-transaction-days-tab";
import ConsentAccountInfoTab from "@/components/consent/consent-account-info-tab";
import ConsentAccountConsentsTab from "@/components/consent/consent-account-consents-tab";

export default {
    name: "consent-account-transaction-days-view",
    components: {ConsentAccountConsentsTab, ConsentAccountInfoTab, ConsentAccountTransactionDaysTab},
    data() {
        return {
            dialog: true,
            tab: 0
        }
    },
    computed: {
        ...mapState('ais', ['activeAccount', 'companyBankAccountNames']),
    },
    watch: {
        dialog: function () {
            if (!this.dialog) {
                this.resetActiveAccount();
            }
        }
    },
    async mounted() {
        await this.getCompanyBankAccountData(this.$route.params.accountId);
        if (this.$route.params.tabId) {
            this.tab = parseInt(this.$route.params.tabId);
        }
    },
    beforeDestroy() {
        this.resetActiveAccount();
    },

    methods: {
        ...mapActions('ais', ['getCompanyBankAccountData']),
        ...mapMutations('ais', ['resetActiveAccount']),
        closeDrawer() {
            this.resetActiveAccount();
            this.$router.push({ name: "consent-list" });
        }
    }
}
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>